export enum ResultType {
  HOTEL = 'HOTEL',
  MESSAGING = 'MESSAGING',
  CAROUSEL = 'CAROUSEL',
  LIST_TITLE = 'LIST_TITLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  STATIC_LODGING_MULTI_ITEM_CROSS_SELL = 'STATIC_LODGING_MULTI_ITEM_CROSS_SELL',
  LODGING_INTENT_CARD = 'LODGING_INTENT_CARD',
  LODGING_CARD = 'LODGING_CARD',
  LODGING_LISTING_DIVIDER = 'LODGING_LISTING_DIVIDER',
  SPONSORED_CONTENT_PLACEMENT = 'SPONSERED_CONTENT_PLACEMENT',
  PROPERTY_SEARCH_SOLDOUT_CARD = 'PROPERTY_SEARCH_SOLDOUT_CARD',
  PROPERTY_SEARCH_OVERFILTERED_CARD = 'PROPERTY_SEARCH_OVERFILTERED_CARD',
  PROPERTY_LISTING_STANDARD_MESSAGING_CARD = 'PROPERTY_LISTING_STANDARD_MESSAGING_CARD',
  PROPERTY_LISTING_EXPANDO_CARD = 'PROPERTY_LISTING_EXPANDO_CARD',
}
